
import Api from "@/api/userService";
import LoadingPage from "@/components/LoadingPage.vue";
import { vehicleStatus } from "@/constant/DataType";
import { car_64, car_86, car_arm, car_arm64 } from "@/constant/DataTypeOptions";
import ResultCodeType from "@/constant/ResultCodeType";
import routerName from "@/router/routerName";
import { message } from "ant-design-vue";
import { defineComponent, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "BasicInformation",
  components: { LoadingPage },
  setup() {
    const { t } = useI18n();
    const canEdit = ref(true);
    const activeKey = ref("1");
    const detail = ref();
    const vin = useRoute().query.vin as string;
    const category_id = useRoute().query.category_id as string;
    const vehicleName = ref("");
    const defaultName = ref("");
    const colorList = [
      "pink",
      "red",
      "orange",
      "green",
      "cyan",
      "blue",
      "purple",
    ];
    const isLoading = ref(false);
    const getListData = () => {
      const params = {
        vin,
        category_id,
      };
      Api.getCarBasicInfo(params).then((res) => {
        console.log(res);
        if (res.err_no == ResultCodeType.success_200) {
          detail.value = res.result;
          vehicleName.value = res.result.vehicle_name;
          editName();
        } else {
          message.error(res.err_msg);
        }
      });
    };
    const carSoftVersion = ref();
    const getCarSoftVersionF = () => {
      const parmObj = {
        vin,
        category_id,
      };
      Api.carVersion(parmObj).then((res) => {
        console.log(res);
        carSoftVersion.value = res.result;
      });
    };

    const carHwVersion = ref();
    const getCarHwVersionF = () => {
      const parmObj = {
        vin,
        category_id,
      };
      Api.carHwVersion(parmObj).then((res) => {
        console.log(res);
        carHwVersion.value = res.result;
      });
    };
    const editName = () => {
      if (vehicleName.value.length > 20) {
        defaultName.value = vehicleName.value.substring(0, 20) + "...";
      } else {
        defaultName.value = vehicleName.value;
      }
    };
    const btnRevise = () => {
      canEdit.value = false;
    };
    const saveVehicleName = () => {
      editName();
      canEdit.value = true;
      let params = {
        vin,
        vehicle_name: vehicleName.value,
      };
      Api.changeVehicleName(params).then(() => {
        getListData();
      });
    };
    const passwordReset = (identity: string) => {
      isLoading.value = true;
      setTimeout(() => {
        isLoading.value = false;
      }, 5 * 1000);
      const params = {
        vin,
        username: identity,
      };
      Api.passwordReset(params).then((val) => {
        if (val.err_no == ResultCodeType.success_200) {
          isLoading.value = false;
          message.success(t("resetsuccessful"));
        } else {
          isLoading.value = false;
          message.error(val.err_msg);
        }
      });
    };
    const cancelVehicleName = () => {
      getListData();
      canEdit.value = true;
    };
    onMounted(() => {
      getListData();
      getCarHwVersionF();
      getCarSoftVersionF();
    });
    return {
      activeKey,
      detail,
      vehicleStatus,
      car_64,
      car_86,
      car_arm,
      car_arm64,
      canEdit,
      editName,
      vehicleName,
      defaultName,
      btnRevise,
      saveVehicleName,
      cancelVehicleName,
      colorList,
      isLoading,
      passwordReset,
      carHwVersion,
      carSoftVersion,
      routerName,
      t,
    };
  },
});
